<p-dialog
	appendTo="body"
	styleClass="w-[95%] max-w-sm kiosk-pin-dialog"
	[header]="header()"
	[visible]="visible()"
	[modal]="true"
	[closable]="!isSubmitting()"
	[draggable]="false"
	[resizable]="false"
	[dismissableMask]="!isSubmitting()"
	(visibleChange)="visibleChange.emit($event)"
>
	<div class="flex flex-col items-center gap-6 px-1 py-2">
		<p class="max-w-[18rem] text-center text-sm leading-relaxed text-gray-600">{{ description() }}</p>

		<form id="kiosk-pin-form" class="w-full" [formGroup]="pinForm" (ngSubmit)="onConfirm()" (keydown.enter)="onEnterKey($event)">
			<div #pinInputHost class="flex justify-center">
				<p-inputotp
					formControlName="pin"
					autofocus
					[integerOnly]="true"
					[length]="USER_PIN_LENGTH"
					[mask]="true"
					[disabled]="isSubmitting()"
				/>
			</div>
			@if (pinForm.get('pin')?.invalid && (pinForm.get('pin')?.dirty || pinForm.get('pin')?.touched)) {
				<p class="mt-4 text-center text-sm text-red-500">PIN must be exactly 4 digits</p>
			}
		</form>
	</div>

	<ng-template #footer>
		<p-button
			[label]="confirmLabel()"
			icon="pi pi-check"
			severity="success"
			fluid
			styleClass="kiosk-pin-dialog-submit"
			[loading]="isSubmitting()"
			[disabled]="pinForm.invalid || isSubmitting()"
			(click)="onConfirm()"
		/>
	</ng-template>
</p-dialog>
